import {Button, CardActions} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import React, {useEffect, useRef, useState} from 'react'
import {VIDEO_REDUCER} from '../../redux/consts'
import {IS_SHOW_PHOTO_OPEN, SHOW_PHOTO_URL} from '../../redux/video/consts'
import styles from './ShowPhotoDialog.module.scss'
import {useDispatch, useSelector} from 'react-redux'
import {
  setIsShowPhotoOpen,
} from '../../redux/actions'
import BasicModal from '../Generic/BasicModal'


export const ShowPhotoDialog = () => {
  const isShowPhotoOpen = useSelector(state => state.getIn([VIDEO_REDUCER,IS_SHOW_PHOTO_OPEN]))
  const showPhotoUrl = useSelector(state => state.getIn([VIDEO_REDUCER,SHOW_PHOTO_URL]))
  const name = showPhotoUrl?.indexOf('hallucination') > -1 ? 'hallucination' : 'photo'
  const setIsOpen = (isOpen) => { dispatch(setIsShowPhotoOpen(isOpen)) }

  const dispatch = useDispatch()
  const intervalRef = useRef(null)

  useEffect(() => {
    if (!isShowPhotoOpen) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
      return
    }

    intervalRef.current = setTimeout(() => {
      dispatch(setIsShowPhotoOpen(false))
    }, 5000)

    return () => {
      if (intervalRef.current) {
        clearTimeout(intervalRef.current)
        intervalRef.current = null
      }
    }
  }, [isShowPhotoOpen, dispatch])



  return <BasicModal
    isOpen={!!isShowPhotoOpen}
    setIsOpen={setIsOpen}
    title={name}
    content={<div className={styles.container}>
      {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
      <img className={styles.image} src={showPhotoUrl} alt="image"/>
    </div>}
    footer={<div>
      <div className={styles.closeContainer}>
        <CardActions sx={{justifyContent: "center"}}>
          <Button onClick={() => setIsOpen(false)}
                  variant="contained"
                  color="primary"
                  type="button"
                  style={{fontSize: '22px'}}
                  startIcon={<CloseIcon/>}
          >Close</Button>
        </CardActions>
      </div>
    </div>}
  />
}
